import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withTranslation } from 'react-i18next';
import colors from 'common/styles/colors';

const TabsRow = styled.div`
  display: flex;
  align-items: stretch;
  align-self: stretch;
  gap: 2px;
`;

const Tab = styled.button`
  border: none;
  background: transparent;
  font-family: inherit;
  font-size: 13px;
  cursor: pointer;
  padding: 15px 12px 13px;
  white-space: nowrap;
  color: ${props => (props.active ? colors.darkGray : colors.lightGray)};
  font-weight: ${props => (props.active ? 700 : 400)};
  border-bottom: 2px solid ${props => (props.active ? props.theme.primaryColor : 'transparent')};
  display: inline-flex;
  align-items: center;
  gap: 7px;

  &:hover {
    color: ${colors.darkGray};
  }
`;

const Count = styled.span`
  font-size: 11px;
  font-weight: 700;
  border-radius: 9px;
  min-width: 20px;
  text-align: center;
  padding: 1px 7px;
  ${(props) => {
    if (props.alert && props.value > 0) return 'background: #fcecec; color: #d92b2b;';
    if (props.active) return 'background: #edf3e1; color: #53682c;';
    return `background: #eff0ee; color: ${colors.lightGray};`;
  }}
`;

const AssetsScopeTabs = ({ scope, onSelectScope, scopes, t }) => (
  <TabsRow>
    {scopes.map((item) => {
      const active = scope === item.id;
      return (
        <Tab
          key={item.id}
          type="button"
          active={active}
          onClick={() => onSelectScope(item.id)}
        >
          {t(item.labelKey, { defaultValue: item.defaultLabel })}
          {item.count != null && (
            <Count active={active} alert={item.alert} value={item.count}>{item.count}</Count>
          )}
        </Tab>
      );
    })}
  </TabsRow>
);

AssetsScopeTabs.propTypes = {
  scope: PropTypes.string.isRequired,
  onSelectScope: PropTypes.func.isRequired,
  scopes: PropTypes.arrayOf(PropTypes.object).isRequired,
  t: PropTypes.func.isRequired
};

export default withTranslation()(AssetsScopeTabs);
